<div class="m-0 bg">
  <!--Navbar-->
  <nav class="navbar navbar-expand-lg navbar-dark b2-navigation">
    <a class="navbar-brand" href="#">
      <img src="/images/bauplus.png" class="mx-2" alt="BauPlus" />
      BauPlus Mobile
    </a>
  </nav>

  <div class="d-flex justify-content-center top-margin-content">
    <div class="col-11 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
      <div id="alert_placeholder"></div>
      <div class="text-center card">
        <div class="card-body m-1 m-md-3 m-lg-4">
          @if (errorMessage()) {
            <div class="mb-4">
              <div class="alert alert-danger text-start py-3" role="alert">
                {{ errorMessage() }}
              </div>
            </div>
          }
          @if (loginInfo(); as info) {
            @if (info.nachrichtTyp > 0) {
              <div class="mb-4">
                <div
                  class="alert text-start py-3"
                  [ngClass]="
                    info.nachrichtTyp === 2 ? 'alert-warning' : info.nachrichtTyp === 3 ? 'alert-danger' : 'alert-info'
                  "
                  [innerHtml]="info.nachricht | safeHtml"
                ></div>
              </div>
            }
          }
          <form name="formular" (ngSubmit)="onSubmit()">
            <mdb-form-control class="form-outline mb-4">
              <input
                mdbInput
                type="text"
                id="cloud"
                name="cloud"
                class="form-control"
                [ngModel]="loginModel().cloud"
                (ngModelChange)="updateLoginField('cloud', $event)"
              />
              <label mdbLabel class="form-label" for="cloud" id="labelCloud">BauPlusCloud Name</label>
            </mdb-form-control>
            <mdb-form-control class="form-outline mb-4">
              <input
                mdbInput
                type="text"
                id="benutzer"
                name="benutzer"
                class="form-control"
                [ngModel]="loginModel().user"
                (ngModelChange)="updateLoginField('user', $event)"
              />
              <label mdbLabel class="form-label" for="benutzer" id="labelBenutzer">Benutzername</label>
            </mdb-form-control>
            <mdb-form-control class="form-outline mb-4">
              <input
                mdbInput
                id="passwort"
                name="passwort"
                class="form-control"
                type="password"
                [ngModel]="loginModel().password"
                (ngModelChange)="updateLoginField('password', $event)"
                (change)="pwChanged()"
              />
              <label mdbLabel class="form-label" for="passwort" id="labelPasswort">Passwort</label>
            </mdb-form-control>
            <div class="d-flex justify-content-center mb-1">
              <div class="form-check m-0">
                <input
                  mdbCheckbox
                  class="form-check-input"
                  type="checkbox"
                  id="keepPassword"
                  name="keepPassword"
                  [ngModel]="keepPassword()"
                  (ngModelChange)="keepPassword.set($event)"
                />
                <label class="form-check-label" for="keepPassword">Passwort merken</label>
              </div>
            </div>
            <button class="btn btn-lg b2-color-delete-reversed mt-4" type="submit" [disabled]="siteLoading()">
              <i class="fal fa-sign-in fa-lg pe-2" aria-hidden="true"></i>
              Anmelden
            </button>
            @if (siteLoading()) {
              <div id="status" class="d-flex justify-content-center pt-3">
                <bpw-loader></bpw-loader>
              </div>
            }
          </form>
        </div>
      </div>
      <div class="version">Version {{ versionShown() }}</div>
    </div>
  </div>
</div>
